import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import DefaultLayout from "@/layouts/default";
import { Card, CardBody, CardHeader } from "@heroui/card";
import ViewMeetsComp from "@/components/meets/view-meets-comp";

const MeetingDetailsPage = () => {
const { short_code } = useParams();
const [audioUrl, setAudioUrl] = useState(null);
const [loading, setLoading] = useState(true);

return (
  <DefaultLayout>
    <ViewMeetsComp _shortCode={short_code}/>
  </DefaultLayout>
);
};

export default MeetingDetailsPage;